/**
 * use-payments — payment_pages + paywall API hooks (ADM-PAY-S001~S003)
 */

import type {
  CreatePaymentPageRequest,
  PaymentPageProductOrderResponse,
  PaymentPageReferencesResponse,
  PaymentPageResponse,
  PaywallConfigResponse,
  ReplacePaymentPageProductOrderRequest,
  UpdatePaymentPageRequest,
  UpsertPaywallRequest,
} from '@novel-admin/shared';
import { apiRequest } from '~/api/client';

export const paymentPagesApi = {
  list: (appId: string) =>
    apiRequest<PaymentPageResponse[]>({
      method: 'GET',
      path: '/api/v1/payment-pages',
      query: { app_id: appId },
    }),
  create: (body: CreatePaymentPageRequest) =>
    apiRequest<PaymentPageResponse>({ method: 'POST', path: '/api/v1/payment-pages', body }),
  update: (id: string, body: UpdatePaymentPageRequest) =>
    apiRequest<PaymentPageResponse>({
      method: 'PATCH',
      path: `/api/v1/payment-pages/${id}`,
      body,
    }),
  /** 删除前引用预检（ADM-PAY-S004）；锁外只读快照，权威校验仍在 DELETE 事务内 */
  listReferences: (id: string) =>
    apiRequest<PaymentPageReferencesResponse>({
      method: 'GET',
      path: `/api/v1/payment-pages/${id}/references`,
    }),
  /** 删除支付页面（ADM-PAY-S004）；server 端校验内建禁删 + scenario 引用 */
  remove: (id: string) =>
    apiRequest<{ id: string }>({
      method: 'DELETE',
      path: `/api/v1/payment-pages/${id}`,
    }),
  listPaywalls: (id: string) =>
    apiRequest<PaywallConfigResponse[]>({
      method: 'GET',
      path: `/api/v1/payment-pages/${id}/paywalls`,
    }),
  upsertPaywall: (id: string, body: UpsertPaywallRequest) =>
    apiRequest<PaywallConfigResponse>({
      method: 'PUT',
      path: `/api/v1/payment-pages/${id}/paywalls`,
      body,
    }),
  /** 页面内商品展示顺序：候选产品全集 + 当前次序（ADM-PAY-S009，A8 §7.9）*/
  getProductOrder: (id: string) =>
    apiRequest<PaymentPageProductOrderResponse>({
      method: 'GET',
      path: `/api/v1/payment-pages/${id}/product-order`,
    }),
  /**
   * 整组替换商品展示顺序（§7.9）。**数组位置即 sort_order**，未列出的产品即「未配序」、
   * 排该板块末尾；空数组 = 清空该页排序配置，是合法运营动作。
   */
  replaceProductOrder: (id: string, body: ReplacePaymentPageProductOrderRequest) =>
    apiRequest<PaymentPageProductOrderResponse>({
      method: 'PUT',
      path: `/api/v1/payment-pages/${id}/product-order`,
      body,
    }),
};
